var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#F8F8F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8206 13.985H12.1795C11.6254 13.985 11.1765 13.5361 11.1765 12.982C11.1765 12.428 11.6254 11.979 12.1795 11.979H25.8206C26.3746 11.979 26.8236 12.4279 26.8236 12.982C26.8236 13.5361 26.3746 13.985 25.8206 13.985Z",
    fill: "#25408F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2037 20.0031H12.1795C11.6254 20.0031 11.1765 19.5542 11.1765 19.0001C11.1765 18.446 11.6254 17.9971 12.1795 17.9971H20.2037C20.7577 17.9971 21.2067 18.446 21.2067 19.0001C21.2067 19.5542 20.7577 20.0031 20.2037 20.0031Z",
    fill: "#25408F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8206 20.0031H24.2158C23.6617 20.0031 23.2128 19.5542 23.2128 19.0001C23.2128 18.446 23.6617 17.9971 24.2158 17.9971H25.8206C26.3747 17.9971 26.8236 18.446 26.8236 19.0001C26.8236 19.5542 26.3747 20.0031 25.8206 20.0031Z",
    fill: "#25408F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8206 26.0212H12.1795C11.6254 26.0212 11.1765 25.5722 11.1765 25.0182C11.1765 24.4641 11.6254 24.0151 12.1795 24.0151H25.8206C26.3746 24.0151 26.8236 24.4641 26.8236 25.0182C26.8236 25.5722 26.3746 26.0212 25.8206 26.0212Z",
    fill: "#25408F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6471,
    height: 15.6471,
    fill: "white",
    transform: "translate(11.1765 11.1765)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu1);
export default __webpack_public_path__ + "static/media/menu1.4a4209ecbdc02147f5485b55bf9b6a3b.svg";
export { ForwardRef as ReactComponent };